export default __webpack_public_path__ + "static/CoreyBaird-2a92aaf4a349f5576761644ae8f8ae59.png";